import { defaultDate, onlyDateWithFullTear } from '@/datas/DateFormats'
import { getDateOfCertainFormat } from '@/helpers/date'

export default {
  props: {
    car: Object,
  },

  methods: {
    changed() {
      // TODO валидация формы
      if (this.returnData.sts_date) {
        const sts_date = getDateOfCertainFormat(
          this.returnData.sts_date,
          defaultDate,
          1,
        )

        this.$emit('changed', { ...this.returnData, sts_date })
      } else {
        this.$emit('changed', this.returnData)
      }
    },
    setDefaultData(data) {
      for (let key in data) {
        if (this.returnData[key] !== undefined) {
          if (key === 'sts_date' && data[key]) {
            data[key] = getDateOfCertainFormat(data[key], onlyDateWithFullTear)

            if (data[key].length > 10) {
              data[key] = null
            }
          }
          this.returnData[key] = data[key]
        }
      }
    },
    changedElement(data) {
      for (let d in data) {
        this.returnData[d] = data[d]
      }
      this.changed()
    },
    setReasonCarrier(reason) {
      this.reasonCarrier = reason
      this.returnData.isOwner = reason

      this.setOwner()
      this.changed()
    },

    changeOwner(data) {
      this.returnData.nameOwner = data.nameOwner
      this.returnData.innOwner = data.innOwner
      this.returnData.innCarrier = data.innCarrier
      this.returnData.nameCarrier = data.nameCarrier
      this.changed()
    },
  },
  watch: {
    auto: {
      immediate: true,
      handler(newVal) {
        this.setDefaultData(newVal)
      },
    },
  },
}
